import { runInAction, makeAutoObservable, action, computed } from "mobx";
import { OrganizationBranchClientDetails } from "../../../../../services/clients/models";
import { getClients } from "../../../../../services/clients";


class ClientsStore {

    limit: number = 10;
    skip: number = 0;
    total: number;
    page: number = 1;
    clients: OrganizationBranchClientDetails[];

    @action
    setLimit(limit: number) {
        this.limit = limit;
    }

    @action
    setSkip(skip: number) {
        this.skip = skip;
    }

    @action
    setPage(page: number) {
        this.page = page;
    }

    @computed
    getPage() {
        return this.page;
    }

    @computed
    getLimit() {
        return this.limit;
    }

    @computed
    getSkip() {
        return this.skip;
    }

    constructor() {
        makeAutoObservable(this)
    }

    async getClients() {
        const response = await getClients({skip: this.skip, limit: this.limit});
        runInAction(() => {
            this.clients = response.clients;
            this.total = response.total;
        })
    }




}


export default ClientsStore
